(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coaching-offers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.getElementById('qc-wrap');
  if (!wrap) return;
  var answers = {};
  var groups = wrap.querySelectorAll('[data-qc-group]');
  var pass = document.getElementById('qc-result-pass');
  var fail = document.getElementById('qc-result-fail');

  function evaluate() {
    var keys = Object.keys(answers);
    if (keys.length < 3) return;
    var allYes = keys.every(function (k) { return answers[k] === 'yes'; });
    pass.classList.toggle('qc-hidden', !allYes);
    fail.classList.toggle('qc-hidden', allYes);
  }

  groups.forEach(function (group) {
    var groupId = group.getAttribute('data-qc-group');
    var buttons = group.querySelectorAll('.qc-opt');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        answers[groupId] = btn.getAttribute('data-value');
        evaluate();
      });
    });
  });

  document.querySelectorAll('[data-interest-tier]').forEach(function (link) {
    link.addEventListener('click', function () {
      var tierSelect = document.getElementById('ci-tier');
      if (tierSelect) { tierSelect.value = link.getAttribute('data-interest-tier'); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
